import { i18n, initLocale } from '@open-songster/ui'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { bootstrap } from './bootstrap'
import '@open-songster/ui/src/styles/tokens.css'
import '@open-songster/ui/src/styles/base.css'
import '@open-songster/ui/src/styles/components.css'

// One URL, two front ends: the device decides which one is downloaded, and
// nothing is mounted until the right one has arrived, so the wrong app never
// flashes.
void bootstrap({
  loaders: {
    mobile: () => import('./variants/mobile'),
    desktop: () => import('./variants/desktop'),
  },
  mount: async (_variant, { App, createRouter }) => {
    // Resolve the language before mounting, so the first paint is already
    // translated rather than flashing English.
    await initLocale().catch(() => undefined)
    createApp(App).use(createPinia()).use(createRouter()).use(i18n).mount('#app')
  },
})
